import { createAssign } from "robodux";
import { put, select } from "saga-query";
import { createSelector } from "reselect";
import { thunks } from "@app/state/apis/api";
import { selectAllShowCaseArr } from "../showCase";
import { selectUserEmail } from "../login";
import * as appConst from "@app/state/constants";

import type {
  TDBShowCase,
  TShowCaseTreelistItem,
  TShowCaseTreeList,
} from "@app/types";
import type { RootState } from "@app/state/rootState";

import { ensureArray } from "@app/service/helpers";
/* 

id: number | string;
  parentId: string | null;
  ptlTitle: string;
  ptlDetail?: string;
  ptlClassName: string;
  ptlGroup: string;
  ptlCfgPage: string;
  ptlSortPosition?: number;
  ptlMeta?: string; // for text search //
  _ptlPerseed?: string;
  ptlParentText?: string;
  touched?: boolean;
*/

const REPO_SHOWCASE_TREELIST = "ui/showcase/treelist";
type TRepoShowcaseTreeList = {
  currentItem: TShowCaseTreelistItem | undefined;
};
export const repoShowCaseTree = createAssign<TRepoShowcaseTreeList>({
  name: REPO_SHOWCASE_TREELIST,
  initialState: {
    currentItem: undefined,
  },
});

const selectShowCaseTreeStore = (state: RootState) =>
  state[REPO_SHOWCASE_TREELIST];
export const selectCurrentShowCaseTreeList = createSelector(
  selectShowCaseTreeStore,
  (state) => state?.currentItem
);

const filterMap = new Map<
  string,
  (rec: TDBShowCase, strVar: string) => boolean
>([
  ["all", (rec: TDBShowCase, strVar: string) => true],
  [
    "common",
    (rec: TDBShowCase, strVar: string) => {
      const emailTerminations = rec.SC_USERNAMES.split(",");
      return emailTerminations.some((emailSuffix) => emailSuffix === "*");
    },
  ],
  [
    "personal",
    (rec: TDBShowCase, strVar: string) => {
      const emailTerminations = rec.SC_USERNAMES.split(",");
      return emailTerminations.some((emailSuffix) => {
        return strVar.includes(emailSuffix.trim());
      });
    },
  ],
  [
    "group",
    (rec: TDBShowCase, strVar: string) => {
      const groups = rec.SC_GROUPS.split(",");
      return groups.some((recGroup) => recGroup === strVar);
    },
  ],
]);

export const selectShowCaseTreeList = createSelector(
  selectAllShowCaseArr,
  (scArr) => {
    const nodeAll = {
      id: "all",
      parentId: null,
      title: "Toate drafturile",
    } as TShowCaseTreeList;

    const nodeCommon = {
      id: "common",
      parentId: null,
      title: "Adresabilitate generala",
      filterPattern: "common",
    } as TShowCaseTreeList;

    const nodePersonal = {
      id: "personal",
      parentId: null,
      title: "Pentru dumneavoastra",
    } as TShowCaseTreeList;

    const nodesByScGroups = scArr.reduce(
      (acc: Record<string, TShowCaseTreeList>, rec: TDBShowCase) => {
        const { SC_GROUPS = [] } = rec;
        const groups = ensureArray(SC_GROUPS);
        groups.forEach((group: string) => {
          if (!acc[group]) {
            acc[group] = {
              id: group,
              parentId: null,
              title: `Catgoria: ${group}`,
            };
          }
        });
        return acc;
      },
      {}
    );

    const allTreeNodes = [
      nodeAll,
      nodeCommon,
      nodePersonal,
      ...Object.values(nodesByScGroups),
    ];

    return allTreeNodes as TShowCaseTreeList[];
  }
);

export const selectShowCardForm = createSelector(
  selectCurrentShowCaseTreeList,
  selectAllShowCaseArr,
  selectUserEmail,
  (currentItem, scArr, email): TDBShowCase[] => {
    const filterKey = currentItem?.id;
    if (!filterKey) return [];
    let filterPattern: (rec: TDBShowCase, strVar: string) => boolean;
    let strVar: string;
    switch (filterKey) {
      case "all":
        filterPattern = filterMap.get("all")!;
        strVar = email;
        break;
      case "common":
        filterPattern = filterMap.get("common")!;
        strVar = email;
        break;
      case "personal":
        filterPattern = filterMap.get("personal")!;
        strVar = email;
        break;
      default:
        filterPattern = filterMap.get("group")!;
        strVar = filterKey;
        break;
    }
    return scArr.filter((rec: TDBShowCase) => filterPattern(rec, strVar));
  }
);

export const setShowCaseTreeList = thunks.create<TRepoShowcaseTreeList>(
  "setShowCaseTreeList",
  function* (ctx, next) {
    const crtstate = yield* select(selectShowCaseTreeStore);
    yield* put(
      repoShowCaseTree.actions.set({ ...crtstate, currentItem: ctx.payload })
    );
  }
);
